// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

const header = document.getElementById('header');
const headerLogo = document.querySelector('.js-scroll-logo');
const burgerMenuBtn = document.getElementById('js-menu-trigger');
const burgerClose = document.getElementById('js-menu-close');

(function(){

	/* Main Nav */

	if(burgerMenuBtn) {
		burgerMenuBtn.addEventListener('click', () =>{
			document.body.classList.toggle('no-scroll');
			header.classList.toggle('menu-open')
		});
	}

	if(burgerClose) {
		burgerClose.addEventListener('click', () =>{
			document.body.classList.remove('no-scroll');
			header.classList.remove('menu-open')
		});
	}

	if(screen.width > 600) {
		document.querySelector('.primary-nav-3').insertAdjacentHTML("afterend", "<br>");

		/* title animation */
	
		document.querySelectorAll('.title.fade-letter').forEach(element => {
			let words = element.textContent.split(' '); 
			let result = ''; 
			let delayIncrement = 0.1;
			let currentDelay = 0; 
		
			words.forEach(word => {
				let singleLetters = word.split(''); 
				singleLetters = singleLetters.map(letter => `<span>${letter}</span>`).join(''); 
				result += `<div class="word">${singleLetters}</div>`; 
				result += ' '; 
			});
		
			element.innerHTML = result.trim(); 
		
			let wordContainers = element.querySelectorAll('.word');
			currentDelay = 0; 
			wordContainers.forEach(wordContainer => {
				let spans = wordContainer.querySelectorAll('span'); 
				spans.forEach(span => {
					span.style.transitionDelay = `${currentDelay}s`;
					currentDelay += delayIncrement; 
				});
			});
		});
	}

	/* Booking Flatpickr */
	if(document.getElementById('home-booking')){
		const fpIn = flatpickr("#home-checkin", {
			dateFormat: "m-d-Y",
			minDate: "today"
		});

		const fpOut = flatpickr("#home-checkout", {
			dateFormat: "m-d-Y",
			minDate: "today"
		});
	};


	/* vanilla JS fancybox */
	if(document.getElementsByClassName('lightbox').length > 0){
		let allLightboxes = document.getElementsByClassName('js-lightboxbtn');
		let allLightboxesLength = allLightboxes.length;

		for(let j = 0; j < allLightboxesLength; j++ ){
			allLightboxes[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.getAttribute('href').split('#')[1];
				document.getElementById(currentTarget).classList.add('open');
				document.body.classList.add('no-scroll');
			});

		}

		let allLightcloses = document.getElementsByClassName('js-lightboxclose');
		let allLightclosesLength = allLightcloses.length;

		for(let j = 0; j < allLightclosesLength; j++ ){
			allLightcloses[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.parentElement.parentElement.id;
				document.getElementById(currentTarget).classList.remove('open');
				document.body.classList.remove('no-scroll');
			});
		}

		let allLbxWraps = document.querySelectorAll('.lightbox');

		for(const lbxWrap of allLbxWraps) {
			lbxWrap.addEventListener('click', (e) => {
				const innerWrap = lbxWrap.querySelector('.lightbox-wrap') ;
				if(!innerWrap.contains(e.target)) {
					allLbxWraps.forEach(el => el.classList.remove('open'));
					document.body.classList.remove('no-scroll');
				}
			})
		}

	};

	
    window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
			parallaxImages();
		})
	};

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		// downscroll code
		if(!header.classList.contains('scroll')){
			header.classList.add('scroll');
			if(headerLogo) {
				changeSrc(headerLogo.getElementsByTagName('img')[0]);
			}
		}
	} else {
		if(header.classList.contains('scroll')){
			header.classList.remove('scroll');
			if(headerLogo) {
				changeSrc(headerLogo.getElementsByTagName('img')[0]);
			}
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

function changeSrc(elem) {
	let target = elem.getAttribute('data-scroll');
	let currentSrc = elem.getAttribute('src');

	elem.setAttribute('src', target);
	elem.setAttribute('data-scroll', currentSrc);
}

function parallaxImages() {
	let windowHeight = window.innerHeight;
	let parallaxElements = document.querySelectorAll('.js-parallax');
	
	if(parallaxElements && screen.width > 900) {
		parallaxElements.forEach(function(element) {
			
			let elementTop = element.getBoundingClientRect().top - 90;
			let elementHeight = element.offsetHeight;
			
			if (elementTop <= 0 && elementTop + elementHeight >= 0) {
				let parallaxOffset = (-elementTop / (windowHeight / 2)) * 35;
				parallaxOffset = Math.min(parallaxOffset, 35);
				parallaxOffset = Math.max(parallaxOffset, 0);
				element.style.transform = 'translate3d(0px, ' + parallaxOffset + '%, 0px)';
			} else {
				element.style.transform = 'translate3d(0px, 0%, 0px)';
			}
		});
	}
}

/** ADA Tab Links Functionality for Keyboard Navigation in Menu **/

function updateMenuTabIndex() {
	const menu = document.querySelector('#header');
	const isMenuVisible = menu && menu.classList.contains('menu-open');
	const elements = document.querySelectorAll('#primary-nav a, #secondary-nav a');
		
	elements.forEach(element => {
			element.setAttribute('tabindex', isMenuVisible ? '0' : '-1');
	});
}
	
document.addEventListener('DOMContentLoaded', () => {
	updateMenuTabIndex();
		
	document.addEventListener('focusin', updateMenuTabIndex);
	
	const menu = document.querySelector('#header');
	if (menu) {
		menu.addEventListener('transitionend', updateMenuTabIndex);
	}
});



